import api from "../../api/api";


const getEssData = () => {
    return new Promise((resolve, reject)=>{
        api.get('ess/master-data').then((res) => {
            //console.log(res.data);
            
            resolve(res.data);
        }).catch(error =>{
            reject("Something went wrong while loading masters");
        })
    })
}


const essMasterServices = {
    getEssData
}

export default essMasterServices;